
import { defineComponent } from 'vue'
import TheFormBankInfo from '@/pages/BankInfoPage/TheFormBankInfo.vue'
import TheHeader from '@/components/layout/TheHeader.vue'
import TheFooter from '@/components/layout/TheFooter.vue'
import NavBarMenuItems from '@/components/common/NavBarMenuItems.vue'
import { ListItemsNavBarBankForm } from '@/config/variables'

export default defineComponent({
    components: {
        TheFormBankInfo,
        TheHeader,
        TheFooter,
        NavBarMenuItems
    },
    setup() {
        return {
            ListItemsNavBarBankForm
        }
    }
})
